import { useEffect, useState } from "react";
import { ResponsiveContainer, LineChart, Line, BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import api from "@/lib/api";

const card = "bg-white dark:bg-neutral-900 border border-brand-line dark:border-neutral-800 rounded-2xl";
const COLORS = ["#D42A2A", "#141414", "#849A86", "#C25838", "#8a8a8a", "#e6b3a3", "#5c5c5c"];

export default function Analytics() {
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setA(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="analytics-page">
      <h1 className="font-display text-4xl">Analytics</h1>
      <p className="text-brand-ink/60 dark:text-white/50 mt-2">Revenue, attendance, growth and locations.</p>
      <div className="mt-8 grid gap-4 lg:grid-cols-2">
        <Chart title="Revenue growth">
          <LineChart data={a?.revenue_by_month || []}><CartesianGrid strokeDasharray="3 3" stroke="#8883" /><XAxis dataKey="month" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} /><Tooltip /><Line type="monotone" dataKey="revenue" stroke="#D42A2A" strokeWidth={2} /></LineChart>
        </Chart>
        <Chart title="Customer growth (sign-ups)">
          <BarChart data={a?.signups_by_month || []}><CartesianGrid strokeDasharray="3 3" stroke="#8883" /><XAxis dataKey="month" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} /><Tooltip /><Bar dataKey="signups" fill="#849A86" radius={[6, 6, 0, 0]} /></BarChart>
        </Chart>
        <Chart title="Attendance trends">
          <BarChart data={a?.attendance_by_month || []}><CartesianGrid strokeDasharray="3 3" stroke="#8883" /><XAxis dataKey="month" tick={{ fontSize: 11 }} /><YAxis tick={{ fontSize: 11 }} /><Tooltip /><Bar dataKey="bookings" fill="#D42A2A" radius={[6, 6, 0, 0]} /></BarChart>
        </Chart>
        <Chart title="Bookings by status">
          <PieChart><Pie data={a?.bookings_by_status || []} dataKey="count" nameKey="status" outerRadius={80} label>{(a?.bookings_by_status || []).map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Pie><Legend /><Tooltip /></PieChart>
        </Chart>
        <div className={`${card} p-6 lg:col-span-2`}>
          <h2 className="font-display text-xl mb-4">Popular locations</h2>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={a?.popular_locations || []} layout="vertical"><CartesianGrid strokeDasharray="3 3" stroke="#8883" /><XAxis type="number" tick={{ fontSize: 11 }} /><YAxis type="category" dataKey="park" width={160} tick={{ fontSize: 11 }} /><Tooltip /><Bar dataKey="attendance" fill="#141414" radius={[0, 6, 6, 0]} /></BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

const Chart = ({ title, children }) => (
  <div className="bg-white dark:bg-neutral-900 border border-brand-line dark:border-neutral-800 rounded-2xl p-6">
    <h2 className="font-display text-xl mb-4">{title}</h2>
    <ResponsiveContainer width="100%" height={240}>{children}</ResponsiveContainer>
  </div>
);
